import { neutral, brand } from '../global';
export const brandBackground = {
    primary: brand[400],
    inputChecked: neutral[100],
    ctaPrimary: neutral[100],
    ctaPrimaryHover: '#E0E0E0',
    ctaSecondary: brand[600],
    ctaSecondaryHover: '#234B8A',
    ctaTertiaryHover: brand[300],
};
//# sourceMappingURL=brand.js.map
